import React from 'react';
import PropTypes from 'prop-types';


class Button extends React.Component {
  render() {
    let className = 'btn ';
    if(this.props.color){
      className = className + this.props.color;
    }else{
      className = className + 'btn-default';
    }

    return (
      <button
        type="button"
        className={className}
        onClick={this.props.onClick.bind(this)}
        style={this.props.style}
      >
        {this.props.text}
      </button>
    )
  }
}

Button.propTypes = ({
  text: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.node,
  ]),
  onClick: PropTypes.func.isRequired,
  color: PropTypes.string,
});


export default Button;



// WEBPACK FOOTER //
// ./src/components/Button.js